import { composeValidators } from './composeValidators';
import { inRange } from './inRange';
import { required } from './required';
import { AdherenceTaskType, HistoricalDataImportTaskType } from '../../scene/integrations/types';

export const validateLookBackPeriod = (
  task: AdherenceTaskType | HistoricalDataImportTaskType,
  min: number,
  max: number
) => {
  return task.scheduled || !!task.cronExpression
    ? composeValidators(required, inRange(min, max))(task.taskProperties?.lookBackPeriod)
    : inRange(min, max)(task.taskProperties?.lookBackPeriod);
};
